
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1js4f_l7ca9_5",
  "tree": "awsui_tree_1js4f_l7ca9_6",
  "treeitem": "awsui_treeitem_1js4f_l7ca9_7",
  "expandable": "awsui_expandable_1js4f_l7ca9_8",
  "expanded": "awsui_expanded_1js4f_l7ca9_9"
};
  